import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

export interface cardDefinition {
  id: string;
  key?: string;
  caption: string;
  activeIcon?: React.ReactElement;
  inactiveIcon?: React.ReactElement;
}

interface SwitchCardsProps {
  cards: cardDefinition[];
  activeCardId: string;
  onSwitchView: (card: cardDefinition) => void;
  className?: string;
}

export const SwitchCards: React.FC<SwitchCardsProps> = ({ cards, activeCardId, onSwitchView, className }) => {
  const handleKeyDown = (e: KeyboardEvent) => {
    cards.forEach((card: cardDefinition) => {
      if (card.key && e.key === card.key) {
        onSwitchView(card);
      }
    });
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <ButtonGroup className={className} size="small">
      {cards.map((card: cardDefinition) => {
        const isActive = activeCardId === card.id;
        return (
          <Button
            key={card.id}
            onClick={() => onSwitchView(card)}
            style={{
              background: isActive ? '#D6D6FB' : '#FFFFFF',
            }}
          >
            {isActive ? card.activeIcon : card.inactiveIcon}
            {card.caption}
          </Button>
        );
      })}
    </ButtonGroup>
  );
};
